(function() {
    'use strict';

    let component = {
        transclude: true,
        templateUrl:
            'app/js/components/contract/trial-end-date-picker-component/trial-end-date-picker.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmTEDP",
        bindings: {
            localDate: '<',
            minDate: '<',
            maxDate: '<',
            onNewTrialEndSelectedAndConfirmed: '&'
        }
    };

    iteroComponents.component('trialEndDatePicker', component);

    controller.$inject = ['gettext','$locale', 'gettextCatalog', 'PUtill', '$rootScope', 'DatepickerUtils'];

    function controller(gettext, $locale, gettextCatalog, PUtill, $rootScope, DatepickerUtils) {
        let ctrl = this;
        let internalModelPrevValue;

        ctrl.$onInit = function () {
            DatepickerUtils.setOptions(ctrl);
            internalModelPrevValue = ctrl.internalModel;
        };

        ctrl.$doCheck = function() {
            DatepickerUtils.turnMinAndMaxDateToBerlin(ctrl);
            
            let valueBeforeSelect = angular.copy(internalModelPrevValue);
            if (!PUtill.areDatesEqual(internalModelPrevValue, ctrl.internalModel)) {
                let currentInLocal = DatepickerUtils.backToBrowserTimezone(ctrl.internalModel);
                let previousInLocal = DatepickerUtils.backToBrowserTimezone(internalModelPrevValue);
                
                let title = gettextCatalog.getString(gettext("Change End Date"));
                let variables = { 'oldVal': previousInLocal, 'newVal': currentInLocal };
                let template = 'app/js/components/contract/trial-end-date-picker-component/trial-end-date-modal-popup-body.html' + itero.linkVersion;

                $rootScope.customPopup(
                    title,
                    template,
                    function () { ctrl.onNewTrialEndSelectedAndConfirmed({ newDate: currentInLocal }); },
                    function () { ctrl.internalModel = internalModelPrevValue = valueBeforeSelect; },
                    function () { ctrl.internalModel = internalModelPrevValue = valueBeforeSelect; },
                    variables);

                internalModelPrevValue = ctrl.internalModel;
            }
        };

        ctrl.$onChanges = function(changes) {
            DatepickerUtils.adjustMinAndMaxDateInOptionsFunc(ctrl, changes)();

            if (ctrl.localDate)
                ctrl.internalModel = internalModelPrevValue = PUtill.convertToDateIfString(ctrl.localDate);
        };

        DatepickerUtils.defineOpen(ctrl);
        DatepickerUtils.defineDisabled(ctrl);
        DatepickerUtils.init(ctrl);
    }
})();
